import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BrushToolIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Circular brush head with soft edges (dotted) */}
      <circle cx="12" cy="12" r="7" stroke={color} strokeWidth={strokeWidth} fill="none" strokeDasharray="2 2" />
      {/* Center dot indicating brush center */}
      <circle cx="12" cy="12" r="2" fill={color} />
    </BaseIcon>
  ),
);

BrushToolIcon.displayName = 'BrushToolIcon';
